/**
 * GameConstants - baseline values for player actors and world geometry.
 * Centralizes dimensions, masses, speeds, and network constants.
 */
export const CHARACTER_HEIGHT = 1.8;
export const CHARACTER_WIDTH = 0.9;
export const CHARACTER_MASS = 10;
export const CHARACTER_MAX_SPEED = 5;
export const CHARACTER_JUMP_SPEED = 20;
export const GROUND_SIZE = 500;
export const GROUND_UV_TILES_PER_UNIT = 0.2;
export const CAMERA_FOV = 60;
export const CAMERA_NEAR = 0.1;
export const CAMERA_FAR = 2000;

// Time to live for net objects, in seconds
export const NET_OBJECT_TTL_SEC = 30;
export const NET_HEARTBEAT_INTERVAL_SEC = 5;
export const NET_PING_INTERVAL_SEC = 1;

// Default multiplayer server port range
export const DEFAULT_SERVER_PORT_MIN = 7777;
export const DEFAULT_SERVER_PORT_MAX = 7780;

export const SerializationVersion = {
  Legacy: 0,
  V1: 1,
  V2: 2,
} as const;
export type SerializationVersion = typeof SerializationVersion[keyof typeof SerializationVersion];
export const CurrentSerializationVersion: SerializationVersion = SerializationVersion.V2;

/***
 * Below are constants not necessarily used by the engine code but they're defined here to be easily shared between downstream projects
 */
export const PROJECT_PATH_PREFIX: string = '@project';
export const ENGINE_PATH_PREFIX: string = '@engine';
export const DEFAULT_GAME_NAME: string = 'game.ts';
export const DEFAULT_GAME_BUNDLE_NAME: string = 'game.js';
export const BUILT_PROJECT_FOLDER: string = '.dist';
export const GAME_PROJECT_FILE_EXT: string = '.genesys-project';
export const DEFAULT_SCENE_KEY: string = 'defaultScene';
export const DEFAULT_SERVER_SCENE_KEY: string = 'defaultServerScene';
export const ENGINE_VERSION_KEY: string = 'engineVersion';
export const ASSETS_FOLDER: string = 'assets';
export const SCENE_NAME_EXT: string = '.genesys-scene';
export const NAVMESH_EXT: string = '.navmesh';
/** Baked lightmap bundle placed beside the matching `.genesys-scene` file. */
export const BUILD_DATA_ZIP_EXT: string = '.build-data.zip';
export const DEFAULT_SCENE_NAME = `default${SCENE_NAME_EXT}`;

export const PREFAB_EXTENSION = '.prefab.json';
export const MATERIAL_EXTENSION = '.material.json';
export const VFX_EXTENSION = '.vfx.json';
export const SKELETON_PROFILE_EXTENSION = '.skeleton-profile.json';

export const UNDEFINED_VALUE = '_udf_';

export const TEXTURE_EXTENSION: string = '.texture.json';
export const DISABLE_TEXTURE_FLIP = true;

export const PACKAGE_NAME: string = '@gnsx/genesys.js';
export const DEFAULT_SKYBOX_TEXTURE_URL: string = '@engine/assets/textures/skybox/citrus_orchard_road_puresky_2k.hdr';
export const DEFAULT_CHARACTER_MODEL_URL: string = '@engine/assets/character/mannequinG.glb';
export const DEFAULT_CHARACTER_ANIMATION_CONFIG_URL: string = '@engine/assets/character/config/mannequin.anim.json';

export const FeatureFlags = {
  /** When enabled, actor initialization options are persisted to savedata and restored on load. */
  PERSIST_INIT_OPTIONS: true,
  /** When enabled, uses a baseline snapshot of initOptions at CDO creation to determine what values differ from defaults. */
  USE_INIT_OPTIONS_BASELINE: true,
};
